<template>
  <div class="fSize">
    <van-list v-model="loading" :finished="finished" :error.sync="error" :error-text="errorText" @load="getList">
      <div v-for="(item,index) in list" class="cell-box" :key="index">
        <van-image class="newImage" width="130" height="130" :round="true" :src="item.imageurl1"
                   @click="goDetail(item.id)"/>
        <div class="text-box" style="margin-left:0.125rem">
          <p class="text">{{ item.name }}</p>
          <p class="text card-type">{{ item.type === 'combo' ? '套餐' : item.type === 'value_card' ? '储值卡' : '代金券' }}</p>
          <p class="text">
            <span>售价</span>
            <span class="colorR">{{ '￥' + (item.price / 100) }}</span>
            <span style="margin-left:4px">原价</span>
            <span style="text-decoration:line-through">{{ '￥' + (item.orgPrice / 100) }}</span>
          </p>
          <p class="text" style="color:#bfbfbf;font-size:0.24rem;">{{ "已售" + item.saleCount + '单' }}</p>
        </div>
      </div>
    </van-list>
    <van-empty v-show="list.length<1" description="暂无套餐数据..."/>
    <!--去用户绑定页面-->
    <van-action-sheet safe-area-inset-bottom :round="false" v-model="show" title="体检用户绑定"
                      :close-on-click-overlay="false" @click-overlay="tipsFun">
      <UserAdd @fatherMethod="closeFun"></UserAdd>
    </van-action-sheet>
  </div>
</template>
<script>
import {
  Button, Toast, ActionSheet, Empty, List, Cell, Image as VanImage, Col
} from "vant";
import {getSetMeal} from "@/api/common";
import UserAdd from "@/components/UserAdd";

export default {
  components: {
    [Button.name]: Button, [Toast.name]: Toast, [ActionSheet.name]: ActionSheet, UserAdd,
    [Empty.name]: Empty, [List.name]: List, [Cell.name]: Cell, [Col.name]: Col, [VanImage.name]: VanImage
  },
  data() {
    return {
      listQuery: {
        page: 1,
        limit: 10,
        openId: sessionStorage.getItem("openid")
      },
      list: [], //套餐列表
      error: false,
      finished: false,
      errorText: "请求失败，点击重新加载",
      loading: false,
      //-----
      show: false
    };
  },
  created() {
    const that = this;
    let id = that.$route.query.id ? that.$route.query.id : that.id;
    if (parseInt(id)) {
      if (!that.isNull()) {
        return false;
      }
      window.removeEventListener(
          "popstate",
          that.closePage
      );
      that.$router.push({
        path: "/buyCardDetail",
        query: {id: parseInt(id)}
      });
    }
    that.reset();
    that.getList();
  },
  mounted() {
    var _this = this;
    window.history.pushState(null, null, "#");
    window.addEventListener(
        "popstate",
        _this.closePage,
        false
    );
  },
  methods: {
    closePage() {
      WeixinJSBridge.call("closeWindow");
    },
    //搜索
    reset() {
      const that = this;
      that.error = false;
      that.list = [];
      that.listQuery.page = 1;
      that.loading = true;
    },
    //判断信息是否为空
    isNull() {
      const that = this;
      if (sessionStorage.getItem("userIsBang") !== "yes") {
        //如果用户信息为空则去设置用户
        that.show = true;
        return false;
      }
      return true;
    },
    //获取套餐列表
    getList() {
      const that = this;
      if (!that.isNull()) {
        return false;
      }
      // 获取购卡套餐列表
      getSetMeal(that.listQuery)
          .then(resp => {
            that.loading = false;
            if (resp.code === 200) {
              that.listQuery.page = that.listQuery.page + 1;
              this.list = [];
              let newArray = resp.data ? resp.data : [];
              that.list.push.apply(that.list, newArray);
            } else {
              that.error = true;
              that.errorText = resp.msg + ",点击重试";
            }
            if (that.list.length >= resp.count) {
              that.finished = true;
            }
          })
          .catch(err => {
            console.log(err);
          });
    },
    //去套餐详情页面
    goDetail(e) {
      const that = this;
      window.removeEventListener(
          "popstate",
          that.closePage
      );
      that.$router.push({path: "/buyCardDetail", query: {id: e}});
    },
    //关闭添加框组件
    closeFun() {
      const that = this;
      that.show = false;
      //刷新列表数据
      that.reset();
      that.getList();
    },
    //判断是否绑定
    tipsFun() {
      if (sessionStorage.getItem("userIsBang") !== "yes") {
        Toast("请先绑定用户信息...");
      }
    }
  }
};
</script>
<style scoped lang="scss">
.cell-box {
  display: flex;
  margin: 0 0.125rem 0.125rem 0.125rem;
  align-items: center;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 0.16rem;
  padding: 0.1rem;

  .newImage {
    width: 100%;
    height: 4rem;
    border-radius: 0.2rem;
  }

  .text {
    font-size: 0.28rem;
    text-align: left;
    font-weight: 700;
    padding-left: 0.26rem;
  }

  .card-type {
    color: #bfbfbf;
    font-size: 0.24rem;
    background: #f5f5f5;
    max-width: 0.95rem;
    display: flex;
    justify-content: center;
    padding: 0 0.12rem;
    margin-left: 0.26rem;
    border-radius: 0.15rem;
  }
}
</style>
